<template>
    <div>
        <h2>{{ deviceFeatures.title }}</h2>

        <div id="anchor-technical-sheet" class="row">
            <!--/* Contenu du pack */-->
            <div v-if="packContent" class="mb-2">
                <p class="lead mb-0">
                    <strong>{{ packContent.title }}</strong>
                </p>
                <p class="mb-0" v-html="packContent.text" />
            </div>

            <!--/* Affichage en tableau mais géré sous forme de liste pour l'accessibilité */-->
            <ul class="list-unstyled">
                <li v-for="(feature, index) in deviceFeatures.technicalFeatures" :key="index" class="list-item">
                    <div v-msh-html="feature.title" class="list-item-title" />
                    <div class="list-item-text">
                        <a
                            v-if="feature.link"
                            class="text-break"
                            :href="feature.text"
                            target="_blank"
                        >
                            {{ feature.text }}
                        </a>
                        <span v-else v-msh-html="feature.text" class="text-break" />
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "DeviceTechnicalFeatures",
    props: {
        deviceFeatures: {
            type: Object,
            required: true,
        }
    },
    computed: {
        packContent() {
            return this.deviceFeatures.packContent;
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_colors';
@import 'ob1_common';
@import 'ob1_variables';

.list-item {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid $white;
}

.list-item-title {
    background-color: $gray4;
    padding: px-to-rem(12) px-to-rem(20);
    width: 35%;
    display: flex;
    align-items: center;
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 20%;
    }
}

.list-item-text {
    background-color: $gray2;
    padding: px-to-rem(10) px-to-rem(20);
    vertical-align: middle;
    display: flex;
    align-items: center;
    width: 65%;
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 80%;
    }
}
</style>
